import "./ArcFlashLabels.module.css";
import Header from "@/reusable_sections/Header";
import ServiceHeroArcFlash from "./sections/ServiceHeroArcFlash";
import ArcFlashLabelingRequirements from "./sections/ArcFlashLabelingRequirements";
import LabelDataFieldsSpecifications from "./sections/LabelDataFieldsSpecifications";
import Capabilities from "./sections/Capabilities";
import HowToOrder from "./sections/HowToOrder";
import ComplianceStandards from "./sections/ComplianceStandards";
import Faq from "./sections/Faq";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ArcFlashLabelsPage() {
  return <div>
      <Header />
      <ServiceHeroArcFlash />
      <ArcFlashLabelingRequirements />
      <LabelDataFieldsSpecifications />
      <Capabilities />
      <HowToOrder />
      <ComplianceStandards />
      <Faq />
      <CallToAction />
      <Footer />
    </div>;
}